import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';
import featureChildren from '../../graphql/queries/featureChildren';
import {
  GetFeatureChildren,
  GetFeatureChildrenVariables,
} from '../../graphql/queries/__generated__/GetFeatureChildren';
import useGetPostCode from '../../../gqlCommon/hooks/useGetPostCode';
import useCustomizeCarContext from '../useCustomizeCarContext';

const useFeatureChildren = () => {
  const { selectedCar } = useCustomizeCarContext();
  const carCode = selectedCar?.car?.byoCode;
  const postCode = useGetPostCode();

  const [query, { data, loading, error }] = useLazyQuery<GetFeatureChildren, GetFeatureChildrenVariables>(
    featureChildren.GET_FEATURE_CHILDREN,
  );

  const loadFeatureChildren = useCallback(
    (newVariables?: Partial<GetFeatureChildrenVariables>) => {
      const abortController = new window.AbortController();

      query({
        variables: {
          carCode,
          postCode,
          featureCode: '',
          ...newVariables,
        },
        context: {
          fetchOptions: {
            signal: abortController.signal,
          },
        },
      });

      return () => abortController.abort();
    },
    [query, carCode, postCode],
  );

  return { data, loading, error, loadFeatureChildren };
};

export default useFeatureChildren;
